/** Ícones do shell do painel, portados 1:1 do artefato P5 (mesma família traço do storefront). */
import type { SVGProps } from 'react';

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export function BrandMark(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2.4} {...p}>
      <path d="M4 7h16l-1.2 11.2A2 2 0 0 1 16.8 20H7.2a2 2 0 0 1-2-1.8L4 7Z" />
      <path d="M8.5 7V5.5a3.5 3.5 0 0 1 7 0V7" />
    </svg>
  );
}

export function IconInicio(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M3 10.5 12 4l9 6.5" />
      <path d="M5 9.5V20h14V9.5" />
      <path d="M9.5 20v-5h5v5" />
    </svg>
  );
}

export function IconProdutos(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M21 8 12 3 3 8l9 5 9-5Z" />
      <path d="M3 8v8l9 5 9-5V8" />
      <path d="m12 13 0 8" />
    </svg>
  );
}

export function IconLoja(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M4 9h16v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9Z" />
      <path d="M3 9 5 4h14l2 5" />
      <path d="M4 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

export function IconVendas(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M6 3h12l1 4v13a1 1 0 0 1-1.5.9L15 20l-2 1.2L11 20l-2 1.2L7 20l-1.5.9A1 1 0 0 1 4 20V7l2-4Z" />
      <path d="M9 9h6M9 13h6" />
    </svg>
  );
}

export function IconAssinantes(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M17 3a4 4 0 0 1 4 4v4" />
      <path d="m18 8-3-3M21 11l-3 3" />
      <path d="M7 21a4 4 0 0 1-4-4v-4" />
      <path d="m6 16 3 3M3 13l3-3" />
    </svg>
  );
}

export function IconDinheiro(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Z" />
      <path d="M3 10h18" />
      <path d="M16 14h2" />
    </svg>
  );
}

export function IconCampanhas(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="m3 11 15-6v14L3 13v-2Z" />
      <path d="M18 8a3 3 0 0 1 0 8" />
      <path d="M6 13v5a1 1 0 0 0 1 1h2" />
    </svg>
  );
}

export function IconAjustes(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} {...p}>
      <path d="M4 7h9M18 7h2M4 12h3M12 12h8M4 17h13M20 17h0" />
      <circle cx="15.5" cy="7" r="2" />
      <circle cx="9" cy="12" r="2" />
      <circle cx="17.5" cy="17" r="2" />
    </svg>
  );
}

export function IconSun(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
    </svg>
  );
}

export function IconBell(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={1.8} {...p}>
      <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </svg>
  );
}

export function IconSearch(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={2} {...p}>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  );
}

export function IconExit(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} strokeWidth={1.9} {...p}>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      <path d="M10 17l5-5-5-5" />
      <path d="M15 12H3" />
    </svg>
  );
}
